import { render, staticRenderFns } from "./RuleUpdatedSuccessfullyModal.vue?vue&type=template&id=50cb592f&"
import script from "./RuleUpdatedSuccessfullyModal.vue?vue&type=script&lang=js&"
export * from "./RuleUpdatedSuccessfullyModal.vue?vue&type=script&lang=js&"
import style0 from "./RuleUpdatedSuccessfullyModal.vue?vue&type=style&index=0&id=50cb592f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports